import { render, staticRenderFns } from "./RheinfireNavigation.vue?vue&type=template&id=4881c74b&scoped=true&"
import script from "./RheinfireNavigation.vue?vue&type=script&lang=js&"
export * from "./RheinfireNavigation.vue?vue&type=script&lang=js&"
import style0 from "./RheinfireNavigation.vue?vue&type=style&index=0&id=4881c74b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4881c74b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VDivider,VNavigationDrawer})
